import { type ClientInferRequest } from "@ts-rest/core";

import { type apiContract } from "../contract";
import { client } from "../client";

type GetMenusRequest = ClientInferRequest<
  typeof apiContract.v1.collect.children.getMenus
>;

type GetMenusArgs = GetMenusRequest["params"] & GetMenusRequest["query"];

export async function getMenus({ tillId, childId }: GetMenusArgs) {
  const response = await client.v1.collect.children.getMenus({
    params: {
      tillId
    },
    query: {
      childId
    }
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}
